// src\components\StaffDetails.jsx (or wherever your public page is)
import React, { useState, useEffect } from "react";
import "../css/StaffDetails.css";

const API_URL = "https://auxititpt.org/Backend/staff_api.php";

// Helper: Get initials from name
const getInitials = (name) => {
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
};

const StaffDetails = () => {
 
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        const activeStaff = data.filter(s => s.status === 'active');
        setStaffList(activeStaff);
      } catch (err) {
        console.error("Failed to fetch staff:", err);
        setError("Unable to load staff details.");
      } finally {
        setLoading(false);
      }
    };

    fetchStaff();
  }, []);

const getPhotoUrl = (photoPath) => {
    if (!photoPath) return null;
    if (photoPath.startsWith("https")) return photoPath;
    return `https://localhost${photoPath}`;
  };

  if (loading) {
    return (
      <section className="staff-container">
        <div className="header">
          <h2>Our Dedicated Staff</h2>
          <p>Loading team members...</p>
        </div>
        <div className="staff-grid">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div className="staff-card skeleton" key={i}>
              <div className="card-header">
                <div className="skeleton-avatar"></div>
                <h3 className="skeleton-text"></h3>
                <p className="skeleton-text sm"></p>
              </div>
              <div className="card-body">
                {[...Array(8)].map((_, j) => (
                  <p className="skeleton-text" key={j}></p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="staff-container">
        <div className="header">
          <h2>Our Dedicated Staff</h2>
          <p className="text-danger">{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="staff-container">
      <div className="header">
        <h2>Our Dedicated Staff</h2>
        <p>
          Meet our team of experienced instructors and coordinators who ensure
          excellence in every trade we offer.
        </p>
      </div>

      <div className="staff-grid">
        {staffList.map((staff) => {
          // Map DB fields to UI fields
          const staffUI = {
            name: staff.name || "—",
            designation: staff.designation || "—",
            trade: staff.trade || "-",
            qualification: staff.qualification || "—",
            dateOfJoining: staff.date_of_joining || "—",
            address: staff.address || "—",
            mobile: staff.mobile_number || "—",
            email: staff.email_id || "—",
            bloodGroup: staff.blood_group || "—",
            dob: staff.date_of_birth || "—",
            photoUrl: staff.staff_photo_url ? getPhotoUrl(staff.staff_photo_url) : null,
            status: staff.status || "active", // Default to active
          };

          return (
            <div className="staff-card" key={staff.staff_id}>
              <div className="card-header">
                {staffUI.photoUrl ? (
                  <img
                    src={staffUI.photoUrl}
                    alt={staffUI.name}
                    className="staff-photo"
                  />
                ) : (
                  <div className="staff-avatar">
                    {getInitials(staffUI.name)}
                  </div>
                )}
                <h3>{staffUI.name}</h3>
                <p className="designation">{staffUI.designation}</p>
              </div>
              <div className="card-body">
                <p><strong>Trade:</strong> {staffUI.trade}</p>
                <p><strong>Qualification:</strong> {staffUI.qualification}</p>
                <p><strong>Date of Joining:</strong> {staffUI.dateOfJoining}</p>
                <p>
                  <strong>Mobile:</strong>{" "}
                  {staffUI.mobile !== "—" ? (
                    <a href={`tel:${staffUI.mobile}`}>{staffUI.mobile}</a>
                  ) : (
                    staffUI.mobile
                  )}
                </p>
                <p>
                  <strong>Email:</strong>{" "}
                  {staffUI.email !== "—" ? (
                    <a href={`mailto:${staffUI.email}`}>{staffUI.email}</a>
                  ) : (
                    staffUI.email
                  )}
                </p>
                <p><strong>Blood Group:</strong> {staffUI.bloodGroup}</p>
                <p><strong>Date of Birth:</strong> {staffUI.dob}</p>
                {/* <p><strong>Status:</strong> {staffUI.status}</p> */}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default StaffDetails;